var map = {
	"./backdrop.svg": "./src/img/backdrop.svg",
	"./contour-wave-2.svg": "./src/img/contour-wave-2.svg",
	"./contour-wave-light.svg": "./src/img/contour-wave-light.svg",
	"./contour-wave.svg": "./src/img/contour-wave.svg",
	"./corner-top-left.svg": "./src/img/corner-top-left.svg",
	"./icon-arrow-right-antracite.svg": "./src/img/icon-arrow-right-antracite.svg",
	"./icon-arrow-right-dark-green.svg": "./src/img/icon-arrow-right-dark-green.svg",
	"./icon-arrow-right-green.svg": "./src/img/icon-arrow-right-green.svg",
	"./icon-arrow-right-white.svg": "./src/img/icon-arrow-right-white.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-hamburger.svg": "./src/img/icon-hamburger.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./src/img/icon-stuurlui-global.svg",
	"./load-more.svg": "./src/img/load-more.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";